module.exports = __webpack_public_path__ + "media/parking_garage.2c0a9528.wav";